module.exports = __webpack_public_path__ + "img/bolaji.85e997c8.jpeg";